module.exports = __webpack_public_path__ + "static/media/fin_dwn2.21a4053b.png";